// import { userService } from '../../services/auth-api.service.js';
import { repairOptionsService } from '../../services/repairOptions-api.service.js'
import router from '../../router.js'

const repairOptionsInitialState = {
  repairOptionsList: [],
  totalExcess: null,
  selectedOption: null,
  instructions: null,
  selectedAddress: null,
  modelVersions: null,
  bookingReference: null,
  bookingDates: null,
  deviceId: null,
  selectedBookingDate: null,
  booking: null,
  paymentResponse: null,
  loading: false
}

export const repairoptionsModule = {
  namespaced: true,
  state: repairOptionsInitialState,
  actions: {
    getRepairOptionsList ({ dispatch, commit, state }, gadgetId) {
      // commit('reset');
      // if (state.repairOptionsList.length == 0) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        repairOptionsService.getByGadgetWebReference(gadgetId)
        .then(
          response => {
            commit('setRepairOptionsList', response.data.availableOptions)
            commit('setTotalExcess', response.data.excessTotal)
            commit('setLoading', false)
            resolve()
          },
          error => {
            commit('setLoading', false)
            reject(error)
          }
        )

      })
      
      // }
    },
    setSelectedRepairOption ({ commit }, payload) {
      commit('setSelectedOption', payload)
    },
    setInstructions ({ commit }, payload) {
      commit('setInstructions', payload)
    },
    setSelectedAddress ({ commit }, payload) {
      commit('setSelectedAddress', payload)
    },
    setModelVersions ({ commit }, payload) {
      commit('setModelVersions', payload)
    },
    setBookingReference ({ commit }, payload) {
      commit('setBookingReference', payload)
    },
    setBookingDates ({ commit }, payload) {
      commit('setBookingDates', payload)
    },
    setPaymentResponse ({ commit }, payload) {
      commit('setPaymentResponse', payload)
    },
    setDeviceId ({ commit }, payload) {
      commit('setDeviceId', payload)
    },
    setBooking ({ commit }, payload) {
      commit('setBooking', payload)
    },
    setLoading ({ commit }, payload) {
      commit('setLoading', payload)
    },
    reset ({ commit }) {
      commit('reset')
    }
  },
  mutations: {
    reset (state) {
      state.repairOptionsList = []
      state.totalExcess = null
      state.selectedOption = null
      state.instructions = null
      state.selectedAddress = null
      state.modelVersions = null
      state.bookingReference = null
      state.bookingDates = null
      state.deviceId = null
      state.selectedBookingDate = null
      state.booking = null
      state.paymentResponse = null
      state.loading = false
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setRepairOptionsList (state, payload) {
      state.repairOptionsList = payload
    },
    setSelectedOption (state, payload) {
      state.selectedOption = payload
    },
    setTotalExcess (state, payload) {
      state.totalExcess = payload
    },
    setInstructions (state, payload) {
      state.instructions = payload
    },
    setSelectedAddress (state, payload) {
      state.selectedAddress = payload
    },
    setModelVersions (state, payload) {
      state.modelVersions = payload
    },
    setBookingReference (state, payload) {
      state.bookingReference = payload
    },
    setBookingDates (state, payload) {
      state.bookingDates = payload
    },
    setDeviceId (state, payload) {
      state.deviceId = payload
    },
    setBooking (state, payload) {
      state.booking = payload
    },
    setPaymentResponse (state, payload) {
      state.paymentResponse = payload
    }
  }
}
